import { MouseEventHandler } from 'react'

import clsx from 'clsx'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  onClickPrev?: MouseEventHandler<HTMLButtonElement>
  onClickNext?: MouseEventHandler<HTMLButtonElement>
  value: string
  next: string
  prev: string
}

const SimplePager = ({ onClickPrev, onClickNext, value, next, prev }: Props) => {
  const buttonClass = 'flex items-center p-1'
  const activeButtonClass =
    'bg-fill-tertiary hover:bg-fill-tertiary-hover active:bg-fill-tertiary-active'
  const disabledButtonClass = 'bg-fill-disabled pointer-events-none'

  return (
    <div className={clsx('flex items-center gap-x-2')}>
      <div className='flex items-stretch gap-x-0.5'>
        <button
          type='button'
          className={clsx(
            buttonClass,
            'rounded-l-lg',
            onClickPrev ? activeButtonClass : disabledButtonClass
          )}
          onClick={onClickPrev}
        >
          <Icon color={onClickPrev ? IconColor.PRIMARY : IconColor.DISABLED} type={IconType.LEFT} />
          <Text size={12} color={onClickPrev ? TextColor.PRIMARY : TextColor.DISABLED}>
            {prev}
          </Text>
        </button>
        <span
          className={clsx(buttonClass, 'bg-fill-tertiary text-primary text-size-12 font-normal')}
        >
          {value}
        </span>
        <button
          type='button'
          className={clsx(
            buttonClass,
            'rounded-r-lg',
            onClickNext ? activeButtonClass : disabledButtonClass
          )}
          onClick={onClickNext}
        >
          <Text size={12} color={onClickNext ? TextColor.PRIMARY : TextColor.DISABLED}>
            {next}
          </Text>
          <Icon
            color={onClickNext ? IconColor.PRIMARY : IconColor.DISABLED}
            type={IconType.RIGHT}
          />
        </button>
      </div>
    </div>
  )
}

export default SimplePager
